export default "__VITE_ASSET__DNcMYPCN__"